import { Component, OnInit, ViewChild,Output,EventEmitter,Input,AfterContentInit } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { NgbActiveModal, NgbTypeahead , NgbDate} from '@ng-bootstrap/ng-bootstrap';
import {Observable, Subject, merge, OperatorFunction} from 'rxjs';
import {debounceTime, distinctUntilChanged, filter, map} from 'rxjs/operators';
import { CompaniesService,AuthService, CandidatesService,CountriesService } from '../../../../services';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-references-modal',
    templateUrl: './references-modal.html',
    styleUrls: ['./references-modal.scss']
})

export class ReferencesModalComponent implements OnInit {
    @ViewChild('instanceComp', {static: false}) Company_instance: NgbTypeahead;
    @ViewChild('instanceAddRef', {static: false}) instanceAddRef: NgbTypeahead;
    @Output() notifyParent = new EventEmitter<any>();
    @Input() isEdit  = false;
    @Input() reference = {
        id :null ,
        relationship : null,
        contact_name : null,
        company : null,
        email : null,
        telephone : null,
        mobile : null,
        company_id:null,
        address_country: null,
        company_name:null,
        address_country_id: null
    }

    companies         = [];
    countries         = [];
    isLoading      = false;
    constructor(private toastr :ToastrService, private countryService: CountriesService,private companiesService: CompaniesService,private candidatesService: CandidatesService,private authService: AuthService, private location: PlatformLocation,public activeModal: NgbActiveModal) {
        location.onPopState(() => { this.activeModal.close();});
    }

    ngOnInit() {
        this.companiesService.getAll().subscribe((res: any) =>{this.companies = res.data;});
        this.countryService.getAll().subscribe((res: any) =>{this.countries = res.data;});
    }

    closeModal(){
        this.activeModal.close({status:true});
    }

    canAdd(){
        return this.isLoading || this.reference.address_country == null || (this.reference.relationship == null || this.reference.contact_name == null || this.reference.email == null);
    }

    updateUserProfile(){
        this.reference.company_id = this.reference.company?.id
        this.reference.address_country_id = this.reference.address_country?.id
        var _ref = Object.assign({},this.reference);
        this.isLoading = true;
        if(!this.isEdit)
            this.candidatesService.addReference(_ref,this.authService.user.candidate?.id).subscribe((res: any) =>{
                this.isLoading = false;
                this.reference = {
                    id :null ,
                    relationship : null,
                    contact_name : null,
                    company : null,
                    email : null,
                    telephone : null,
                    mobile : null,
                    company_id:null,
                    address_country: null,
                    company_name:null,
                    address_country_id: null
                };
                this.notifyParent.emit(true);
                this.closeModal();
            },(error)=>{
                this.isLoading = false;
                this.toastr.error("Something wrong, try again later", "Add Reference");
            });
        else
            this.candidatesService.updateReference(_ref,this.authService.user.candidate?.id,this.reference.id).subscribe((res: any) =>{
                this.isLoading = false;
                this.reference = res.data;
                this.notifyParent.emit(true);
                this.closeModal();
            },(error)=>{
                this.isLoading = false;
                this.toastr.error("Something wrong, try again later", "Update Reference");
            });
    }

    selectCompany(){
        this.reference.company_name     = (typeof this.reference.company == 'string') ? this.reference.company : null;
    }

    compnay_formatter = (company: any) => company.company_name_en;
    compnay_focus$ = new Subject<string>();
    compnay_click$ = new Subject<string>();
    compnay_search: OperatorFunction<string, readonly {id, compnay_name_en}[]> = (text$: Observable<string>) => {
        text$.pipe(debounceTime(200),distinctUntilChanged());
        const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
        const clicksWithClosedPopup$ = this.compnay_click$.pipe(filter(() => !this.Company_instance.isPopupOpen()));
        const inputFocus$ = this.compnay_focus$;

        return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(map(term => (term === '' ? this.companies.slice(0, 10)
        : this.companies.filter(company => new RegExp(term, 'mi').test(company.compnay_name_en)).slice(0, 10)))
    )}

    formatter = (country: any) => country.country_name_en;    
    add_focus$ = new Subject<string>();
    add_click$ = new Subject<string>();    
    add_search: OperatorFunction<string, readonly {id, country_name_en}[]> = (text$: Observable<string>) => {
        text$.pipe(debounceTime(200),distinctUntilChanged());
        const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
        const clicksWithClosedPopup$ = this.add_click$.pipe(filter(() => !this.instanceAddRef.isPopupOpen()));
        const inputFocus$ = this.add_focus$;

        return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(map(term => (term === '' ? this.countries
        : this.countries.filter(country => new RegExp(term, 'mi').test(country.country_name_en)).slice(0, 10)))
    )}    
}